import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; 
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";

import "./Footer.css";
import { Instagram } from "@mui/icons-material";

function Footer() {

    const popularCourses = [
        {
            name: "Python",
            link: "/python-courses-pay-after-learn",
        },
        {
            name: "Artificial Intelligence (AI)",
            link: "/ai-courses-pay-after-learn",
        },
        {
            name: "Machine Learning / Deep Learning",
            link: "/machine-learning-courses-pay-after-learn",
        },
        {
            name: "Data Science",
            link: "/data-science-courses-pay-after-learn",
        },
      {
            name: "NX Open Customization & Automation",
            link: "/nx-open-customization-automation-training",
        },
       {
            name: "CATIA Customization & Automation",
            link: "/catia-caa-customization-automation-training",
        },
    ];

    const cadCourses = [
        {
            name: "NX Open Customization & Automation",
            link: "/nx-open-customization-automation-training",
        },
        {
            name: "CATIA Customization & Automation",
            link: "/catia-caa-customization-automation-training",
        },
        {
            name: "CATIA Python Automation",
            link: "/python-catia-automation-customization",
        },
        {
            name: "CREO Customization & Automation",
            link: "/creo-toolkit-customization-training",
        },
        {
            name: "SolidWorks Automation & Customization",
            link: "/solidworks-api-customization-automation-training",
        },
        {
            name: "AutoCAD Automation",
            link: "/autocad-api-customization-automation-online-courses",
        },
        {
            name: "Revit Automation & Customization",
            link: "/autodesk-revit-api-customization-automation-course",
        },
        {
            name: "Inventor API Customization & Automation",
            link: "/autodesk-inventor-api-customization-automation-course",
        },
        {
            name: "Teamcenter PLM Customization",
            link: "/teamcenter-plm-customization-training-itk-rac-soa-awc",
        },
        {
            name: "PTC Windchill PLM Customization",
            link: "/ptc-windchill-plm-customization-course",
        },
    ];

    const aiProjects = [
        {
            name: "RAG AI Project",
            link: "/ai-ml-project-rag-retrieval-argument-generation",
        },
        {
            name: "Automated IT Ticketing System using AI",
            link: "/replace-it-help-desk-with-automated-ticketing-system-using-ai",
        },
        {
            name: "Brain Stroke Prediction using AI",
            link: "/ai-ml-project-brain-stroke-prediction-opencv-cnn",
        },
        {
            name: "Image Classification Using AI",
            link: "/ai-ml-project-image-classification-deep-learning",
        },
        {
            name: "AI Powered Manufacturing Quality Control",
            link: "/ai-ml-project-intelligent-manufacturing-quality-control-system",
        },
    ];

    return (
        <footer className="feesworth-footer mt-5">

            {/* ==========================================
                MAIN FOOTER
            =========================================== */}

            <div className="footer-container">

                {/* ==========================================
                    BRAND / ABOUT
                =========================================== */}

                <div className="footer-brand">

                    <a href="/" className="footer-logo">
                        <img
                            src="/Fees_logo.webp"
                            alt="FeesWorth"
                        />

                        <span>FeesWorth</span>
                    </a>


                    <p className="footer-about">
                        Learn from experts, build real-world projects
                        and develop the skills needed to grow your
                        career in technology.
                    </p>



                    <div className="footer-contact">

                        <div className="footer-contact-item">

                            <LocationOnIcon />

                            <span>
                                FeesWorth, 2nd Floor,<br />
                                DSU Innovation Campus,<br />
                                Kudlu Gate, Bangalore,<br />
                                India - 560068
                            </span>

                        </div>


                        <div className="footer-contact-item">

                            <EmailIcon />

                            <a href="mailto:contact@feesworth.com">
                                contact@feesworth.com
                            </a>

                        </div>

                    </div>


                    {/* SOCIAL MEDIA */}

                    <div className="footer-social">

                        <a
                            href="https://www.instagram.com/feesworth_training"
                            aria-label="Instagram"
                        >
                            <Instagram />
                        </a>

                        <a
                            href="https://www.youtube.com/@FeesWorth"
                            aria-label="YouTube"
                        >
                            <YouTubeIcon />
                        </a>

                        <a
                            href="https://www.facebook.com/feesworth"
                            aria-label="Facebook"
                        >
                            <FacebookIcon />
                        </a>

                    </div>

                </div>


                {/* ==========================================
                    POPULAR COURSES
                =========================================== */}

                <div className="footer-column">

                    <h3>
                        Popular Courses
                    </h3>


                    <ul>

                        {popularCourses.map((course, index) => (

                            <li key={index}>

                                <a href={course.link}>

                                    <ArrowForwardIcon />

                                    {course.name}

                                </a>

                            </li>

                        ))}

                    </ul>

                </div>


                {/* ==========================================
                    CAD AUTOMATION
                =========================================== */}

                <div className="footer-column">

                    <h3>
                        CAD Automation Courses
                    </h3>


                    <ul>

                        {cadCourses.map((course, index) => (

                            <li key={index}>

                                <a href={course.link}>

                                    <ArrowForwardIcon />

                                    {course.name}

                                </a>

                            </li>

                        ))}

                    </ul>

                </div>


                {/* ==========================================
                    AI PROJECTS
                =========================================== */}

                <div className="footer-column">

                    <h3>
                        AI Project Based Training
                    </h3>


                    <ul>

                        {aiProjects.map((project, index) => (

                            <li key={index}>

                                <a href={project.link}>

                                    <ArrowForwardIcon />

                                    {project.name}

                                </a>

                            </li>

                        ))}

                    </ul>

                </div>

            </div>


            {/* ==========================================
                BOTTOM BAR
            =========================================== */}

            <div className="footer-bottom">

                <div className="footer-bottom-container">

                    <p>
                        © {new Date().getFullYear()} FeesWorth.
                        All Rights Reserved.
                    </p>


                    <div className="footer-bottom-links">

                        <a href="/privacy-policy">
                            Privacy Policy
                        </a>

                        <span>|</span>

                        <a href="/terms-conditions">
                            Terms & Conditions
                        </a>

                        <span>|</span>

                        <a href="/contact">
                            Contact Us
                        </a>

                    </div>

                </div>

            </div>

        </footer>
    );
}

export default Footer;